/**
 * Cấp ngân sách
 */
export default {
    AllProvince: 1,  // toàn tỉnh
    Province: 2,  // cấp tỉnh
    District: 3, // cấp huyện
  };
  